import { cx } from '@/utils/cx'
import schriftzug from '../../marke/veeky-schriftzug.png'

/**
 * Die Wortmarke VeeKy — Symbol und Schriftzug, ohne Untertitel.
 *
 * **Als Bild, nicht als Schrift.** Der Schriftzug im Logo ist eigens
 * gezeichnet, und der Schwung des „y" läuft im Verlauf des Symbols aus;
 * in einer Schrift aus dem Bau nachgesetzt sähe er anders aus.
 * `packages/ui/marke/veeky-schriftzug.png` ist das Logo ohne die
 * Untertitelzeile.
 */

export interface WortmarkeProps {
  /** Beisatz rechts der Marke, durch einen Trennstrich abgesetzt. */
  beisatz?: string
  className?: string
}

export function Wortmarke({ beisatz, className }: WortmarkeProps) {
  return (
    <span className={cx('flex items-center gap-2.5', className)}>
      <img src={schriftzug} alt="VeeKy" className="h-7 w-auto select-none" draggable={false} />
      {beisatz ? (
        <span className="border-l border-secondary pl-2.5 text-xs text-tertiary">{beisatz}</span>
      ) : null}
    </span>
  )
}
